import router from './router'
import store from './store'
import {} from '@/api/api'
router.beforeEach(async (to, from, next) => {
    var _hmt = _hmt || [];
    window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
    if (_hmt) {
        if (to.path) {
            _hmt.push(['_trackPageview', '/' + to.fullPath]);
        }
    }
    // let menuList = ["/cn/company","/cn/healthcare","/cn/consumerData","/cn/marketResearch","/cn/markets","/cn/media","/cn/contact"];
    let menuList = ["/cn/company", "/cn/qualitative", "/cn/quantitative", "/cn/patient", "/cn/healthcare", "/cn/markets", "/cn/media", "/cn/contact"];
    menuList.forEach((item, index) => {
        if(item.indexOf(to.path) > -1){
            localStorage.setItem('menuTab', index);
        }
    })
    if(to.path == '/' || to.path == '/cn/index'){
        localStorage.setItem('menuTab', -1);
    }
    if(to.path.indexOf('/cn') > -1){
        localStorage.setItem('lang', 1);
        localStorage.setItem('language', 1);

    }else{
        localStorage.setItem('lang', 0);
        localStorage.setItem('language', 0);

    }
    store.commit("changeLang");
    store.commit("changeMenu");
    next();
})

router.afterEach(() => {

})
